import React, { useState } from "react";
import RecentSearches from "../RecentSearches";
import FormSearches from "../FormSearches";

function AdvancedTab({ setOpen, selectOptions, dynamicFilterData }) {
  const [searchData, setSearchData] = useState({});

  return (
    <div className="search-tab-items flex gap-6 justify-center advance-tab">
      <FormSearches
        setOpen={setOpen}
        selectOptions={selectOptions}
        setSearchData={setSearchData}
        searchData={searchData}
      />
      <RecentSearches setOpen={setOpen} selectOptions={dynamicFilterData} />
    </div>
  );
}

export default AdvancedTab;
